// extracted by mini-css-extract-plugin
module.exports = {"titleSubtitleWrapper":"title-subtitle-module--titleSubtitleWrapper--1nCn7","title":"title-subtitle-module--title--1fIkm"};